module.exports = __webpack_public_path__ + "img/kn_flag.ab8ee103.svg";